import { StaffRights } from './StaffRights'

export interface StaffExtendedUser {
    userId: number
    active: boolean
    id: number
    email: string
    firstname: string
    lastname: string
    phone: string
    address: string
    city: string
    zip: string
    country: string
    degree: Diplomas
}

export interface Staff {
    id: number
    email: string
    firstname: string
    lastname: string
    phone: string
    address: string
    city: string
    zip: string
    country: string
    degree: Diplomas
    dataSharingConsent?: boolean
}

export interface StaffWithLinks {
    email: string
    userId: number
    active: boolean
    id: number
    firstname: string
    lastname: string
    phone: string
    address: string
    city: string
    zip: string
    country: string
    degree: Diplomas
    staffLinks: StaffLevelRights[]
}

export interface StaffLevelRights extends StaffRights {
    level: number
    daycareId: number
}

export interface StaffLink extends StaffLevelRights {
    notifReport: boolean

    notifNewParent: boolean
    notifPushNewParent: boolean

    notifUpdateParent: boolean
    notifPushUpdateParent: boolean

    notifNewStaff: boolean
    notifPushNewStaff: boolean

    notifConfirmation: boolean
    notifPushConfirmation: boolean

    notifCancellation: boolean
    notifPushCancellation: boolean

    notifRequestSlot: boolean
    notifPushRequestSlot: boolean

    notifEventDays: boolean
    notifPushEventDays: boolean

    notifRegularSlot: boolean
    notifPushRegularSlot: boolean

    notifTaskNote: boolean
    notifPushTaskNote: boolean
}

export enum Diplomas {
    bafa = 'BAFA',
    aepe = 'AEPE',
    deap = 'DEAP',
    deeje = 'DEEJE',
    atsem = 'ATSEM',
    dep = 'DEP',
    dei = 'DEI',
    no = 'no',
    other = 'other'
}
